import { useCallback } from "react";

import type { DiscountOrdinary } from "@/lib/gql/__generated__/graphql";

import { FeatureIslandCategoryQuestionForMain } from "@/components/features/_layouts/island/main-with-category/components/category-main-question";

import { CheckboxField } from "@/components/ui/form/fields/check-box-field/check-box";

import { ActiveDiscountsList } from "./active-discounts-list";

type Props = {
	isNotDiscountTarget: {
		value: boolean | null | undefined;
		error?: string;
		isEdited: boolean;
	};
	onSetIsNotDiscountTarget: (value: boolean) => void;
	activeDiscounts: Pick<DiscountOrdinary, "discountID" | "name" | "hotelID">[];
	title: string;
	description: React.ReactNode;
};

export const QuestionIsNotDiscountTarget = ({
	isNotDiscountTarget,
	onSetIsNotDiscountTarget: _onSetIsNotDiscountTarget,
	activeDiscounts,
	title,
	description,
}: Props) => {
	const onSetIsNotDiscountTarget = useCallback(
		(value: boolean) => {
			_onSetIsNotDiscountTarget(value);
		},
		[_onSetIsNotDiscountTarget],
	);

	return (
		<FeatureIslandCategoryQuestionForMain
			required={false}
			title={"ディスカウント適用設定"}
			isEdited={isNotDiscountTarget.isEdited}
			hasError={Boolean(isNotDiscountTarget.error)}
			inputChildren={
				<div className="space-y-4">
					<CheckboxField
						value={isNotDiscountTarget.value ?? false}
						label={"ディスカウントの適用対象から外す"}
						handleChange={onSetIsNotDiscountTarget}
						errorMessage={isNotDiscountTarget.error}
					/>
					{/* 注意書き */}
					{description}
					{!isNotDiscountTarget.value && (
						<ActiveDiscountsList activeDiscounts={activeDiscounts} title={title} />
					)}
				</div>
			}
		/>
	);
};

QuestionIsNotDiscountTarget.displayName = "QuestionIsNotDiscountTarget";
